// extracted by mini-css-extract-plugin
export default {"root":"MyDeaprtmentPage_root__ScFnS","header":"MyDeaprtmentPage_header__Jp6J5","btn_container":"MyDeaprtmentPage_btn_container__AOeRa","list":"MyDeaprtmentPage_list__cMyLR"};